import WaitLayer from "./WaitLayer";

export default WaitLayer;
